export enum FilterType {
  MultiChoice = 'MultiChoice',
  SingleCoice = 'SingleCoice',
  CheckBox = 'CheckBox',
  ValueRange = 'ValueRangee',
  DateRange = 'DateRange'
}
